import { cn } from "@/lib/utils";

export type EditorTab = "write" | "preview";

const TABS: { id: EditorTab; label: string }[] = [
	{ id: "write", label: "Write" },
	{ id: "preview", label: "Preview" },
];

// "header": GitHub-style tabs joined to the editor frame.
// "pill": compact toggle for the floating toolbar.
export function EditorTabs({
	value,
	onChange,
	variant,
}: {
	value: EditorTab;
	onChange: (tab: EditorTab) => void;
	variant: "header" | "pill";
}) {
	return (
		<div role="tablist" className="flex">
			{TABS.map(({ id, label }) => {
				const active = value === id;
				return (
					<button
						key={id}
						type="button"
						role="tab"
						aria-selected={active}
						onClick={() => onChange(id)}
						className={cn(
							"text-sm transition-colors",
							variant === "header"
								? "-mb-px h-10 border border-transparent px-4 first:rounded-tl-md"
								: "h-7 rounded px-2.5 text-xs",
							active
								? variant === "header"
									? "border-border border-b-surface bg-surface font-medium text-foreground first:border-l-transparent"
									: "bg-muted-subtle font-medium text-foreground"
								: "text-muted-foreground hover:text-foreground",
						)}
					>
						{label}
					</button>
				);
			})}
		</div>
	);
}
